module.exports = __webpack_public_path__ + "img/ruler.9ef5bf06.svg";